import { recoverSavedState } from '../actions';

class InteractionInterface {
	constructor(loaderAppElement, loaderExternalInterface, store) {
		this.loaderAppElement = loaderAppElement;
		this.loaderExternalInterface = loaderExternalInterface;
		this.store = store;
		this.type = 'AaPronunciation';
	}
	recoverableState({ currentItem, correctAnswers, itemsToShow, randomItemsOrder, itemsMarkedText }) {
		let recoverable = false;
		const { exercise } = this.store.getState();
		const itemsLength = exercise.items.length;

		if (
			(currentItem === null || currentItem < itemsLength) &&
			(itemsMarkedText.length <= itemsLength) &&
			(correctAnswers.length <= itemsLength) &&
			(itemsToShow === exercise.itemsToShow) &&
			((randomItemsOrder && exercise.randomItems) || (!randomItemsOrder && !exercise.randomItems))
		) {
			recoverable = true;
		}

		return recoverable;
	}
	recoverSavedState(recoveriesCount, learnerResponse) {
		this.store.dispatch(recoverSavedState(learnerResponse));
	}
	getContainer() {
		return this.loaderAppElement;
	}
	updateInteraction(learnerResponse) {
		const {
			exercise: { currentItem, resultsVisible, correctAnswers, randomItemsOrder, itemsToShow, questionsAnswered, itemsMarkedText, phoneme },
			feedback,
			loader: { testSent, itemsWithAudio }
		} = this.store.getState();

		learnerResponse.currentItem = currentItem;
		learnerResponse.resultsVisible = resultsVisible;
		learnerResponse.correctAnswers = correctAnswers;
		learnerResponse.questionsAnswered = questionsAnswered;
		learnerResponse.itemsMarkedText = itemsMarkedText;
		if (randomItemsOrder) {
			learnerResponse.randomItemsOrder = randomItemsOrder;
		}
		if (itemsToShow) {
			learnerResponse.itemsToShow = itemsToShow;
		}
		learnerResponse.feedback = feedback.map(e => ((e && e.type !== 'recording' && e.type !== 'analysis') ? e : undefined));
		learnerResponse.testSent = testSent;
		learnerResponse.itemsWithAudio = itemsWithAudio;
		learnerResponse.phoneme = phoneme;
	}
	hasLoaded() {
		return this.loaderExternalInterface.appLoaded;
	}
	getVersion() {
		return this.store.getState().loader.version;
	}
	getType() {
		return this.type;
	}
}

export default InteractionInterface;
